// extracted by mini-css-extract-plugin
export default {"notesListing":"ClientNotes_notesListing__ZkmT+","ellipsisBtn":"ClientNotes_ellipsisBtn__xa11T","ellipsisIcon":"ClientNotes_ellipsisIcon__OTQkd"};